import { Component, Input}    from '@angular/core';

@Component({
  template: require('./transaction-expanded-row.component.html')
})
export class TransactionExpandedRowComponent {
  @Input() row: any;
}